'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var borders = {
  none: 0,
  '1px': '1px solid',
  '2px': '2px solid',
  '4px': '4px solid',
  '8px': '8px solid'
};
exports["default"] = borders;